export const normalizeChatDataStoreInclusions = (resp) => {
    if (Array.isArray(resp?.message)) {
        return resp.message;
    }

    if (Array.isArray(resp?.message?.dataStores)) {
        return resp.message.dataStores;
    }

    return [];
};
